module.exports = {"hero":{"title":"Keep on top of the HR trends with us!","subtitle":"Keep up to date on lastest trends and updates with all things HR. Check out our most recent post below and subscribe to our blog so you can stay updated. "},"recommended":"Our recommended articles","read-articles-in":"I want to read articles in","all-categories":"All categories","blog-articles":"Blog Articles","subscribe":{"title":"Sign up for our email updates and stay updated"}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr/blog.json
// module id = vWaq
// module chunks = 0